// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import template from "./evaluation-searcher.html";
import baoRouter from "./../../services/bao-router";

function EvaluationSearcher(params) {
    var self = this;
    self.Bao = Bao;
    self.subscriptions = [];
    self.Models = ko.observableArray([]);
    self.PageIndex = ko.observable(0);
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.IsLoading = ko.observable(false);
    self.Sorting = ko.observableArray([]);
    self.SelectedRow = ko.observable();
    if (ko.isObservable(params.mode)) {
        self.Mode = params.mode;
    }
    else {
        self.Mode = ko.observable(params.mode);
        if (params.mode == undefined) {
            self.Mode("evaluation");
        }
    }
    if (ko.isObservable(params.matchCodes)) {
        self.MatchCodes = params.matchCodes;
    }
    else {
        self.MatchCodes = ko.observable(params.matchCodes);
    }
    if (ko.isObservable(params.folderStructureChecklistId)) {
        self.FolderStructureChecklistId = params.folderStructureChecklistId;
    }
    else {
        self.FolderStructureChecklistId = ko.observable(params.folderStructureChecklistId);
    }
    if (ko.isObservable(params.folderStructureId)) {
        self.FolderStructureId = params.folderStructureId;
    }
    else {
        self.FolderStructureId = ko.observable(params.folderStructureId);
    }
    if (ko.isObservable(params.displayMode)) {
        self.DisplayMode = params.displayMode;
    }
    else {
        self.DisplayMode = ko.observable(params.displayMode);
        if (params.displayMode == undefined) {
            self.DisplayMode("list");
        }
    }
}
;
EvaluationSearcher.prototype.NewEvaluation = function (item) {
    var self = this;
    self.IsLoading(true);
    return Bao.post("Checkware/Evaluation/InitNew", JSON.stringify({
        folderStructureChecklistId: item.FolderStructureChecklistId,
        matchCodes: JSON.stringify(ko.map.toJS(self.MatchCodes))
    }), function (evaluationId) {
        baoRouter.setHash("checkware/evaluation/" + evaluationId);
    }).always(function () {
        self.IsLoading(false);
    });
};
EvaluationSearcher.prototype.CustomFilter = function () {
    var customFilter = [];
    customFilter.push({
        Key: "matchcode",
        Value: JSON.stringify(ko.map.toJS(this.MatchCodes))
    });
    var folderStructureArray = [];
    if (typeof this.FolderStructureId() === "string") {
        folderStructureArray.push(this.FolderStructureId());
    }
    else {
        folderStructureArray = this.FolderStructureId();
    }
    customFilter.push({
        Key: "folderstructureid",
        Value: JSON.stringify(ko.map.toJS(folderStructureArray))
    });
    var folderStructureChecklistArray = [];
    if (typeof this.FolderStructureChecklistId() === "string") {
        folderStructureChecklistArray.push(this.FolderStructureChecklistId());
    }
    else {
        folderStructureChecklistArray = this.FolderStructureChecklistId();
    }
    customFilter.push({
        Key: "folderstructurechecklistid",
        Value: JSON.stringify(ko.map.toJS(folderStructureChecklistArray))
    });
    return customFilter;
};
EvaluationSearcher.prototype.Refresh = function () {
    var self = this;
    self.IsLoading(true);
    return Bao.post("Checkware/Evaluation/Componentsearch", JSON.stringify({
        pageIndex: self.PageIndex(),
        pageSize: self.PageSize(),
        customFilter: self.CustomFilter(),
        sorting: self.Sorting(),
        mode: self.Mode()
    }), function (result) {
        self.TotalRows(result.Count);
        self.Models(result.Models);
        self.IsLoading(false);
    });
};
EvaluationSearcher.prototype.init = function () {
    return this.Refresh();
};
EvaluationSearcher.prototype.dispose = function () {
    for (var i = 0; i < this.subscriptions.length; i++) {
        this.subscriptions[i].dispose();
    }
    if (console != null && console.log != null) {
        console.log("Evaluation Searcher disposed");
    }
};
export default {
    viewModel: EvaluationSearcher,
    template: template
};
;